import styled from "styled-components";

export const MatchingEntitiesSectionStyled = styled.div`
  .matching-entities-section {
    padding-bottom: 0px;
  }
`;
